import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-28 pb-16 px-4 bg-white text-center" data-id="element-163">
      <div className="max-w-4xl mx-auto" data-id="element-164">
        <div className="inline-block bg-brand-light text-brand-amber font-bold px-4 py-1 rounded-full mb-6 border border-brand-amber/20" data-id="element-165">
          🔥 ARSENAL DEL SOLDADOR 24HS
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-black text-brand-dark mb-3 leading-tight tracking-tight" data-id="element-166">
          De Empleado a Creador: <br className="hidden md:block" data-id="element-167" />
          Aprendé el Oficio que te da <br className="hidden md:block" data-id="element-168" />
          <span className="text-brand-amber underline decoration-brand-forge decoration-4 md:decoration-8 underline-offset-4 md:underline-offset-8" data-id="element-169">
            Libertad Financiera Real
          </span>
        </h1>

        <a href="#compra" className="block cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 mb-8 mt-8" data-id="element-170">
          <img src="https://cdn.magicpatterns.com/uploads/2FfumGWEQBmcJHzgog7GL7/heylloyd-image-1773353141010.png" alt="Arsenal del Soldador 24hs — Mega Pack Maestro Carpintero del Acero" className="w-full max-w-3xl mx-auto drop-shadow-2xl" data-id="element-171" />
        </a>

        <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-4" data-id="element-172">
          ARSENAL DEL SOLDADOR 24HS — Mega Pack Completo — por Guía Digital 360
        </h2>

        <p className="text-lg sm:text-xl md:text-2xl italic text-gray-600 font-medium mb-8" data-id="element-173">
          "Pasá de depender de un sueldo a generar entre 1.000 y 3.000 USD
          fabricando muebles industriales."
        </p>

        <p className="text-base sm:text-lg md:text-xl text-gray-700 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-174">
          El único Mega Pack en Argentina que te da todo lo que necesitás para
          aprender el oficio, fabricar muebles que se venden solos y construir
          tu propio negocio desde las manos.
        </p>

        <div className="flex flex-wrap justify-center gap-4 mb-10" data-id="element-175">
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-176">
            📄 100% PDF
          </span>
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-177">
            ⚡ Acceso inmediato
          </span>
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-178">
            🇦🇷 Hecho en Argentina
          </span>
        </div>

        <div className="max-w-2xl mx-auto mb-6" data-id="element-179">
          <CTAButton text="🔥 → QUIERO MI ARSENAL AHORA" href="#compra" isLink={true} data-id="element-180" />
        </div>

        <div className="flex flex-wrap justify-center items-center gap-6 text-sm md:text-base text-gray-600 font-medium" data-id="element-181">
          <span className="flex items-center gap-1" data-id="element-182">
            <ShieldCheckIcon className="w-5 h-5 text-brand-green" data-id="element-183" /> Garantía 7
            días sin preguntas
          </span>
          <span className="flex items-center gap-1" data-id="element-184">
            <LockIcon className="w-5 h-5 text-gray-500" data-id="element-185" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-186">
            <CreditCardIcon className="w-5 h-5 text-brand-steel" data-id="element-187" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}